import React from 'react';
import '../../../../i18next';
import st from './styles.module.scss';
import TopBar from './TopBar';
import TopHeader from './TopHeader';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const paths = ['/view/jobs', '/view/intern', '/view/comp', '/faq', '/privacy-policy'];
  const isJobsOrInternOrCompaniesPathname = paths.includes(location.pathname);
  return (
    <header
      className={`${st.header} ${isJobsOrInternOrCompaniesPathname ? st.headerNoTopBar : ''}`}
    >
      {!isJobsOrInternOrCompaniesPathname && <TopBar />}
      <TopHeader />
    </header>
  );
};

export default Header;
